// extracted by mini-css-extract-plugin
module.exports = {"triangle":"Triangle__triangle___SBeDe","triangle--visible":"Triangle__triangle--visible___2Sycv","triangle--down":"Triangle__triangle--down___3GMKB"};